<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">Home</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      会员管理
      <small>使用商城的会员...</small>
    </h1>
    <!-- end page-header -->
    <panel title="会员列表">
      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.username" placeholder="名称"></Input>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
      </Row>
      <Table :columns="columns" :data="datas" class="m-t-10">
        <template slot="logo" slot-scope="{row}">
          <img :src="row.portrait" style="max-width:60px" />
        </template>
        <template slot="action" slot-scope="{row}">
          <button type="button" class="btn btn-theme m-r-5" @click="fn_show_order(row.id)">订单历史</button>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="filterCond.page"
        :page-size="filterCond.pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer :closable="false" title="订单历史" width="80" v-model="v_show">
      <Table class="m-t-10" :columns="ordercolumns" :data="orderList">
        <template slot="ordertype" slot-scope="{row}">
          <span v-if="row.ordertype =='goods'">商品订单</span>
          <span v-else-if="row.ordertype =='recharger'">充值订单</span>
        </template>

        <template slot="orderstatus" slot-scope="{row}">
          <span v-if="row.orderstatus == -1" style="color:red">取消</span>
          <span v-else-if="row.orderstatus == -2" style="color:red">删除</span>
          <span v-else-if="row.orderstatus == 0">未收货</span>
          <span v-else-if="row.orderstatus == 1" style="color:green">
            已收货
            <i class="fa fa-check"></i>
          </span>
        </template>

        <template slot="paystatus" slot-scope="{row}">
          <span v-if="row.paystatus == 0">未付款</span>
          <span v-else-if="row.paystatus == 1" style="color:green">
            已付款
            <i class="fa fa-check"></i>
          </span>
        </template>
        <template slot="shippingstatus" slot-scope="{row}">
          <span v-if="row.shippingstatus == 0">未发货</span>
          <span v-else-if="row.shippingstatus == 1" style="color:green">
            已发货
            <i class="fa fa-check"></i>
          </span>
        </template>
        <template slot="ordergoods" slot-scope="{row}">
          <span v-if="row.ordertype =='goods'">
            <p
              v-for="(item,index) in row.ordergoods"
              :key="index"
            >{{item.goods_name}} * {{item.goods_number}} * ￥{{item.promotion_price}}</p>
          </span>
          <span v-else-if="row.ordertype =='recharger'">{{row.remarks}}</span>
        </template>
        <template slot-scope="{row}" slot="remarks">
          <span v-if="row.ordertype =='goods'">{{row.remarks}}</span>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="orderList_totalRows"
        :current="orderFilterCond.page"
        :page-size="orderFilterCond.pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPageOrder"
      />
    </Drawer>
  </div>
</template>
<script>
import { getMemberList, getMemberOrderList } from "@/api/members";
export default {
  data() {
    return {
      columns: [
        {
          title: "#ID",
          key: "id",
          width: 50
        },
        {
          title: "名称",
          key: "name",
          width: 180
        },
        {
          title: "头像",
          slot: "logo",
          width: 100
        },
        {
          title: "注册日期",
          key: "regtime",
          width: 180
        },
        {
          title: "总余额",
          key: "totalbalance",
          width: 100
        },
        {
          title: "余额",
          key: "balance",
          width: 100
        },
        {
          title: "佣金",
          key: "commission",
          width: 100
        },
        {
          title: "积分",
          key: "integral",
          width: 100
        },
        {
          title: "最近登录",
          key: "lastlogin",
          width: 180
        },

        {
          title: "操作",
          slot: "action"
        }
      ],
      datas: [],
      totalRows: 0,
      formData: {},
      v_show: false,
      filterCond: {
        page: 1,
        pageNum: 10,
        username: ""
      },
      orderList: [],
      orderFilterCond: {
        page: 1,
        pageNum: 10,
        userid: ""
      },
      orderList_totalRows: 0,
      showUserId: 0,
      ordercolumns: [
        {
          title: "#ID",
          key: "id",
          width: 50
        },
        {
          title: "订单号",
          key: "order_sn",
          width: 180
        },
        {
          title: "订单类型",
          slot: "ordertype",
          width: 100
        },
        {
          title: "商品",
          slot: "ordergoods",
          minWidth: 180
        },
        {
          title: "付款状态",
          slot: "paystatus",
          width: 100
        },
        {
          title: "发货状态",
          slot: "shippingstatus",
          width: 100
        },
        {
          title: "运费",
          key: "expressfee",
          width: 120
        },
        {
          title: "订单金额",
          key: "orderamount",
          width: 120
        },
        {
          title: "消耗积分",
          key: "exchangeintegral",
          width: 100
        },
        {
          title: "备注",
          slot: "remarks"
        },
        {
          title: "订单状态",
          slot: "orderstatus",
          width: 100
        }
      ]
    };
  },
  mounted() {
    this.fn_load(this.filterCond);
  },
  methods: {
    fn_query() {
      this.fn_load(this.filterCond);
    },
    fn_load(filterCond) {
      getMemberList(filterCond)
        .then(res => {
          this.datas = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      this.filterCond.page = page;
      this.fn_load(this.filterCond);
    },
    fn_show_order(userid) {
      this.showUserId = userid;
      this.orderFilterCond.userid = userid;
      getMemberOrderList(this.orderFilterCond)
        .then(res => {
          this.orderList = res.data.data;
          this.orderList_totalRows = res.data.total;
          this.v_show = true;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPageOrder(page) {
      this.orderFilterCond.page = page;
      this.fn_show_order(this.showUserId);
    }
  }
};
</script>